export const colorPalette = [
  {
    bg: 'bg-[#94D2BD]',
    light: 'bg-[#94D2BD]/10',
    text: 'text-[#2D6A5D]',
    accent: 'from-[#94D2BD]/10',
  },
  {
    bg: 'bg-[#B8B8FF]',
    light: 'bg-[#B8B8FF]/10',
    text: 'text-[#5D5DA8]',
    accent: 'from-[#B8B8FF]/10',
  },
  {
    bg: 'bg-[#FFD6A5]',
    light: 'bg-[#FFD6A5]/10',
    text: 'text-[#9A7B4F]',
    accent: 'from-[#FFD6A5]/10',
  },
  {
    bg: 'bg-[#FFADAD]',
    light: 'bg-[#FFADAD]/10',
    text: 'text-[#A65D5D]',
    accent: 'from-[#FFADAD]/10',
  },
  {
    bg: 'bg-[#A0C4FF]',
    light: 'bg-[#A0C4FF]/10',
    text: 'text-[#5075A8]',
    accent: 'from-[#A0C4FF]/10',
  },
  {
    bg: 'bg-[#CAFFBF]',
    light: 'bg-[#CAFFBF]/10',
    text: 'text-[#5A8A4F]',
    accent: 'from-[#CAFFBF]/10',
  },
];

export const getColorForIndex = (index: number) => colorPalette[index % colorPalette.length];

export const getInitials = (title: string) => title.charAt(0).toUpperCase();

